import React from "react";
import EditIcon from "@material-ui/icons/EditOutlined";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import locale from "@bonliva-crm/locale";
import {
  EventLog_EventFragment as Event
} from "@graphql";
import { ButtonOptions, FloatingMenu } from "@components/FloatingMenu";
import StickIcon from "@material-ui/icons/InfoOutlined";

type Props = {
  event: Event;
  onEdit: () => void;
  onDelete: () => void;
  onPin: () => void;
  className?: string;
};

export function CustomerContractEventFloatingMenu(props: Props) {
  const { className, event } = props;
  const buttons: ButtonOptions[] = [];

  if (event.CanPin) {
    buttons.push({
      key: "pin-log-item",
      icon: <StickIcon fontSize="inherit" />,
      onClick: props.onPin,
      title: locale.Sticky,
      titleDisabled: locale.NoPermissions,
      disabled: false
    });
  }

  if (event.CanEdit) {
    buttons.push({
      key: "edit-log-item",
      icon: <EditIcon fontSize="inherit" />,
      onClick: props.onEdit,
      title: locale.Edit,
      titleDisabled: locale.NoPermissions,
      disabled: false
    });
  }

  if (event.CanDelete) {
    buttons.push({
      key: "delete-log-item",
      icon: <DeleteIcon fontSize="inherit" />,
      onClick: props.onDelete,
      title: locale.Delete,
      titleDisabled: locale.NoPermissions,
      disabled: !event.CanDelete
    });
  }

  return <FloatingMenu className={className} buttons={buttons} />;
}
